import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Card from '@/modules/common/components/Card';
import Spinner from '@/modules/common/components/Spinner';
import ErrorFetch from '@/modules/common/components/ErrorFetch';
import { formatDateTime, getInternalStatus, formatPrice } from '~/common';
import Item from './Item';

const Information = (props) => {
    // noinspection JSUnresolvedVariable
    return (
        <Card>
            <CardHeader title="Детальная информация"/>
            <CardContent className={(props.loading) ? 'loading' : ''}>
                {(!props.loading)
                    ? <>
                        {(props.lead)
                            ? <>
                                <Item name="ID заявки" value={props.lead.adv_sub}/>
                                {(props.lead.offer)
                                    ? <>
                                        <Item name="ID оффера" value={props.lead.offer.offer_id}/>
                                        <Item name="Название оффера" value={props.lead.offer.offer_name}/>
                                    </>
                                    : null
                                }
                                {(!props.user.affiliate)
                                    ? <>
                                        <Item name="ID партнера" value={props.lead.affiliate_id}/>
                                        <Item name="Имя партнера" value={props.lead.affiliate_name}/>
                                    </>
                                    : null
                                }
                                {(props.lead.type)
                                    ? <>
                                        <Item name="Тип заявки" value={props.lead.type.code}/>
                                        <Item name="Название типа заявки" value={props.lead.type.name}/>
                                    </>
                                    : null
                                }
                                <Item name="Дата/Время" value={formatDateTime(new Date(props.lead.datetime))}/>
                                <Item name="Souce" value={props.lead.source} checkNull={true}/>
                                <Item name="Affiliate Sub" value={props.lead.aff_sub} checkNull={true}/>
                                {(!props.user.affiliate)
                                    ? <>
                                        <Item name="Affiliate Sub2" value={props.lead.aff_sub2} checkNull={true}/>
                                        <Item name="Affiliate Sub3" value={props.lead.aff_sub3} checkNull={true}/>
                                        <Item name="Affiliate Sub4" value={props.lead.aff_sub4} checkNull={true}/>
                                        <Item name="Adv Sub" value={props.lead.adv_sub2} checkNull={true}/>
                                        <Item name="Adv Sub 2" value={props.lead.adv_sub3} checkNull={true}/>
                                        <Item name="Adv Sub 3" value={props.lead.adv_sub4} checkNull={true}/>
                                        <Item name="Adv Sub 4" value={props.lead.adv_sub5} checkNull={true}/>
                                    </>
                                    : null
                                }
                                <Item name="Дата/Время статуса"
                                      value={formatDateTime(new Date(props.lead.datetime_status))}/>
                                {(props.lead.status)
                                    ? <>
                                        <Item name="Статус" value={props.lead.status.status}/>
                                        <Item name="Код статуса" value={props.lead.status.code}/>
                                        <Item name="Внутренний статус"
                                              value={getInternalStatus(props.lead.status.internal)}/>
                                    </>
                                    : null
                                }
                                <Item name="Цена" value={props.lead.price} fmtValue={formatPrice(props.lead.price)}
                                      checkNull={true}/>
                                <Item name="ID транзакции" value={props.lead.transaction_id} checkNull={true}/>
                                {(!props.user.affiliate)
                                    ? <>
                                        <Item name="Идентификатор URL" value={props.lead.url_id} checkNull={true}/>
                                        <Item name="Комментарий" value={props.lead.comment} checkNull={true}/>
                                    </>
                                    : null
                                }
                            </>
                            : <ErrorFetch onClick={() => props.fetch()}/>
                        }
                    </>
                    : <Spinner/>
                }
            </CardContent>
        </Card>
    );
};

Information.propTypes = {
    loading: PropTypes.bool.isRequired,
    lead: PropTypes.object,
    fetch: PropTypes.func.isRequired,
};

export default connect(
    (state) => ({
        user: state.auth.user,
    }),
    null
)(Information);
